import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, UrlSegment } from '@angular/router';
import { Subscription } from 'rxjs';
import { Error429Service } from 'src/app/services/error429.service';
import { UserDataService } from 'src/app/services/user-data.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from '../../../../environments/environment';
import { MatTabChangeEvent } from '@angular/material/tabs';
interface Clientes {
  value: number;
  name: string;
}
interface Establecimientos {
  establecimientoId: number;
  clienteId: number;
  name: string;
}
@Component({
  selector: 'app-editar-usuario',
  templateUrl: './editar-usuario.component.html',
  styleUrls: ['./editar-usuario.component.css']
})
export class EditarUsuarioComponent implements OnInit, OnDestroy {

  tipoUsuario: any;
  tipoUsuarioRecuperacion: any;
  estado: number = 1;
  errorName: boolean = false;
  errorEmail: boolean = false;
  errorEmailNoti: boolean = false;
  errorContrasenha: boolean = false;
  errorContrasenhaIguales: boolean = false;
  usuarioEditado: boolean = false;
  errorFinal: boolean = false;
  errorFinalMessage: string = "";
  clientsData: any = [];
  tiempoEsperaRecarga: number = 60000;
  errorMessage: string = "";
  showClienteError: boolean = false;
  usersData: any = [];
  userId: any;
  userData: any = [];
  waitAfterSave: boolean = false;
  es_estrella: boolean = false;
  es_corporativo: boolean = false;

  //ESTABLECIMIENTOS
  establecimientos: Establecimientos[] = [];
  establecimientosCopia: Establecimientos[] = [];
  selectAllEstablecimientos: boolean = false;
  selectedEstablecimiento: number[] = [];

  clientes: Clientes[] = [
  ];
  selectedCliente: number | undefined;

  signin: FormGroup = new FormGroup({
    name: new FormControl(''),
    email: new FormControl('', [Validators.email]),
    emailNoti: new FormControl('', [Validators.email]),
    password: new FormControl('', [Validators.minLength(4)]),
    passwordR: new FormControl('', [Validators.minLength(4)])
  });

  hide = true;
  hideR = true;
  userDataSer: any = [];

  private clientsSubscription: Subscription | undefined;
  private usersSubscription: Subscription | undefined;
  private editarUsuarioSubscription: Subscription | undefined;

  constructor(private userService: UserService, private router: Router, private error429: Error429Service,
    private userDataService: UserDataService) {
    this.userId = this.getClienteIdFromCurrentPath(router);
    this.userDataSer = this.userDataService.getUserData();
  }

  ngOnInit(): void {
    this.es_estrella = this.userDataSer.es_estrella === '1';
    this.usersSubscription = this.userService.getUsers().subscribe({
      next: resp => {
        this.usersData = resp;
        for (let i = 0; i < this.usersData.length; i++) {
          if (this.usersData[i].id == this.userId) {
            this.userData = this.usersData[i];
            this.es_corporativo = this.userData.is_corporative;
          }
        }
      }, error: err => {
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete: () => {
        this.signin.patchValue({
          name: this.userData.user_fullname,
          email: this.userData.email,
          emailNoti: this.userData.user_mail
        });

        this.tipoUsuario = this.userData.pro_id;
        this.tipoUsuarioRecuperacion = 4;
        this.estado = this.userData.user_status;
        this.selectedCliente = this.userData.cliente_id;

        //Conseguir los clientes
        this.clientsSubscription = this.userService.getClients().subscribe({
          next: resp => {
            for (let i = 0; i < resp.length; i++) {
              this.clientsData.push(resp[i]);
              this.clientes.push({
                value: resp[i].id,
                name: resp[i].razon_social
              });
              if (resp[i].establishments.length !== 0) {
                for (let j = 0; j < resp[i].establishments.length; j++) {
                  this.establecimientos.push({
                    establecimientoId: resp[i].establishments[j].id,
                    clienteId: resp[i].establishments[j].est_cliente_id,
                    name: resp[i].establishments[j].est_name
                  });
                }
              }
            }
            if (this.clientes.length === 1) {
              this.selectedCliente = this.clientes[0].value;
            }
            //this.establecimientosCopia = this.establecimientos;
            const establecimientosFiltrados = this.establecimientos.filter(est => est.clienteId === this.userData.cliente_id);
            this.establecimientosCopia = establecimientosFiltrados;
          }, error: err => {
            if (err.status == 429) {
              this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
              this.recargarPaginaDespuesDeTiempo();
            } else {
              this.errorMessage = err.error.message;
            }
          }, complete: () => {
            if (this.userData.acl_establishments.length !== 0) {
              for (let i = 0; i < this.userData.acl_establishments.length; i++) {
                //Seleccionar los establecimientos del usuario
                this.selectedEstablecimiento.push(this.userData.acl_establishments[i].est_id)
              }
            }
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    }
    if (this.usersSubscription) {
      this.usersSubscription.unsubscribe();
    }
    if (this.editarUsuarioSubscription) {
      this.editarUsuarioSubscription.unsubscribe();
    }
  }

  clienteSeleccionado() {
    this.selectedEstablecimiento = [];
    const establecimientosFiltrados = this.establecimientos.filter(est => est.clienteId === this.selectedCliente);
    this.establecimientosCopia = establecimientosFiltrados;
  }

  selectAllEstablecimientosChanged() {
    if (this.selectAllEstablecimientos) {
      this.selectedEstablecimiento = this.establecimientosCopia.map(establecimiento => establecimiento.establecimientoId);
    } else {
      this.selectedEstablecimiento = [];
    }
  }

  getClienteIdFromCurrentPath(router: Router): number {
    const urlTree = router.parseUrl(router.url);
    const segments: UrlSegment[] = urlTree.root.children['primary'].segments;
    // Buscamos el segmento que contiene el número
    let deviceId: number | null = null;
    for (const segment of segments) {
      const value = parseInt(segment.path, 10);
      if (!isNaN(value)) {
        deviceId = value;
        break;
      }
    }
    return deviceId || 0;
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  get nameInput() {
    return this.signin.get('name');
  }
  get emailInput() {
    return this.signin.get('email');
  }
  get emailNotiInput() {
    return this.signin.get('emailNoti');
  }
  get passwordInput() {
    return this.signin.get('password');
  }
  get passwordRInput() {
    return this.signin.get('passwordR');
  }

  clearField(fieldName: string) {
    this.signin.get(fieldName)?.setValue('');
  }

  removeGoogleapiScript() {
    const scriptSrc = "https://maps.googleapis.com/maps/api/js?key=" + environment.googleAPIKey + "&libraries=places&callback=initMap";
    // Buscar el script existente
    const existingScript = document.querySelector(`script[src^="${scriptSrc}"]`);
    if (existingScript) {
      // Eliminar el script si existe
      document.head.removeChild(existingScript);
    }
  }

  logout() {
    this.userService.logOut();
    //Eliminamos el token de sesion
    //this.userService.deleteSessionToken();
    this.userService.removeLocalSessionToken();
    //Eliminados los datos de usuario del local storage
    this.userDataService.clearUserData();
    //Eliminamos el error del local storage
    this.error429.clearError();
    //Eliminar el script de google maps
    this.removeGoogleapiScript();
    /* La cookie que guarda el token de sesion de elimina pero es necesario redirigir al /login
    ya que sino hay que esperar a que el usuario intente cargar otra vista para que el authorize-guard
    devuelva true y redirija al /login */
    this.router.navigateByUrl("/login");
  }

  guardarUsuario() {
    if (this.es_estrella) {
      if (this.es_corporativo) {
        if (this.nameInput?.value == "") {
          this.errorName = true;
        } else {
          this.errorName = false;
        }
        //Que el email exista y sea valido
        if (this.emailInput?.valid) {
          this.errorEmail = false;
        } else {
          this.errorEmail = true;
        }
        //Que el email si existe que sea valido
        if (this.emailNotiInput?.value === '' || this.emailNotiInput?.valid) {
          this.errorEmailNoti = false;
        } else {
          this.errorEmailNoti = true;
        }

        //Comprobar que no haya ningún error y crear el usaurio
        if (this.errorEmail == false && this.errorEmailNoti == false && this.errorContrasenha == false && this.errorContrasenhaIguales == false && !this.errorName) {

          let user = {
            _method: "PATCH",
            user_id: this.userId,
            email: this.emailInput?.value,
            is_corporative: true,
            user_mail: this.emailNotiInput?.value,
            user_fullname: this.nameInput?.value,
            pro_id: this.tipoUsuario,
            cliente_id: this.selectedCliente,
            user_status: this.estado,
            acl_establishments: JSON.stringify(this.selectedEstablecimiento),
          };

          this.editarUsuarioSubscription = this.userService.updateUser(user).subscribe({
            next: resp => {
              // console.log(resp);
            }, error: err => {
              this.errorFinalMessage = err.error.message;
              const errorFields = err.error?.error;

              if (errorFields) {
                this.errorFinalMessage = Object.keys(errorFields)
                  .map(field => errorFields[field].join(', '))
                  .join(' | ');
              } else {
                this.errorFinalMessage = err.message || 'Error desconocido';
              }
              if (!this.waitAfterSave) {
                this.waitAfterSave = true;
                this.errorFinal = true;
                setTimeout(() => {
                  this.errorFinal = false;
                  this.waitAfterSave = false;
                }, 3500)
              }
            }, complete: () => {
              if (!this.waitAfterSave) {
                this.waitAfterSave = true;
                this.usuarioEditado = true;
                setTimeout(() => {
                  this.usuarioEditado = false;
                  this.waitAfterSave = false;
                  if (this.userDataSer.id == this.userData.id) {
                    this.logout();
                  }
                }, 3500);
              }
            }
          })
        }

        /*console.log("Nombre: ", this.nameInput?.value);
        console.log("El ID de usuario es: ", this.userId);
        console.log("Correo electrónico: ", this.emailInput?.value);
        console.log("Contraseña: ", this.passwordInput?.value);
        console.log("Contraseña Repetida: ", this.passwordRInput?.value);
        console.log('El cliente seleccionado es: ', this.selectedCliente);
        console.log("Tipo de Usuario: ", this.tipoUsuario);
        console.log("Estado: ", this.estado);
    
        console.log('---------------------------------------');*/
      } else {
        if (this.nameInput?.value == "") {
          this.errorName = true;
        } else {
          this.errorName = false;
        }
        //Que el email exista y sea valido
        if (this.emailInput?.valid) {
          this.errorEmail = false;
        } else {
          this.errorEmail = true;
        }
        //Que el email si existe que sea valido
        if (this.emailNotiInput?.value === '' || this.emailNotiInput?.valid) {
          this.errorEmailNoti = false;
        } else {
          this.errorEmailNoti = true;
        }

        if (this.passwordInput?.value && this.passwordInput.value.length < 4) {
          this.errorContrasenha = true;
        } else {
          this.errorContrasenha = false;
        }
        //Error contraseña iguales
        if (this.passwordInput?.value === this.passwordRInput?.value) {
          this.errorContrasenhaIguales = false;
        } else {
          this.errorContrasenhaIguales = true;
        }

        //Comprobar que no haya ningún error y crear el usaurio
        if (this.errorEmail == false && this.errorEmailNoti == false && this.errorContrasenha == false && this.errorContrasenhaIguales == false && !this.errorName) {

          let user = {
              _method: "PATCH",
              user_id: this.userId,
              email: this.emailInput?.value,
              user_pass1: this.passwordInput?.value,
              user_pass2: this.passwordRInput?.value,
              user_mail: this.emailNotiInput?.value,
              user_fullname: this.nameInput?.value,
              pro_id: this.tipoUsuarioRecuperacion,
              cliente_id: this.selectedCliente,
              user_status: this.estado,
              acl_establishments: JSON.stringify([]),
            };;
          

          this.editarUsuarioSubscription = this.userService.updateUser(user).subscribe({
            next: resp => {
              // console.log(resp);
            }, error: err => {
              this.errorFinalMessage = err.error.message;
              const errorFields = err.error?.error;

              if (errorFields) {
                this.errorFinalMessage = Object.keys(errorFields)
                  .map(field => errorFields[field].join(', '))
                  .join(' | ');
              } else {
                this.errorFinalMessage = err.message || 'Error desconocido';
              }
              if (!this.waitAfterSave) {
                this.waitAfterSave = true;
                this.errorFinal = true;
                setTimeout(() => {
                  this.errorFinal = false;
                  this.waitAfterSave = false;
                }, 3500)
              }
            }, complete: () => {
              if (!this.waitAfterSave) {
                this.waitAfterSave = true;
                this.usuarioEditado = true;
                setTimeout(() => {
                  this.usuarioEditado = false;
                  this.waitAfterSave = false;
                  if (this.userDataSer.id == this.userData.id) {
                    this.logout();
                  }
                }, 3500);
              }
            }
          })
        }

        /*console.log("Nombre: ", this.nameInput?.value);
        console.log("El ID de usuario es: ", this.userId);
        console.log("Correo electrónico: ", this.emailInput?.value);
        console.log("Contraseña: ", this.passwordInput?.value);
        console.log("Contraseña Repetida: ", this.passwordRInput?.value);
        console.log('El cliente seleccionado es: ', this.selectedCliente);
        console.log("Tipo de Usuario: ", this.tipoUsuario);
        console.log("Estado: ", this.estado);
    
        console.log('---------------------------------------');*/
      }
    } else {
      if (this.nameInput?.value == "") {
        this.errorName = true;
      } else {
        this.errorName = false;
      }
      //Que el email exista y sea valido
      if (this.emailInput?.valid) {
        this.errorEmail = false;
      } else {
        this.errorEmail = true;
      }
      //Que el email si existe que sea valido
      if (this.emailNotiInput?.value === '' || this.emailNotiInput?.valid) {
        this.errorEmailNoti = false;
      } else {
        this.errorEmailNoti = true;
      }
      //Error no hay contraseña
      if (this.passwordInput?.value && this.passwordInput.value.length < 4) {
        this.errorContrasenha = true;
      } else {
        this.errorContrasenha = false;
      }
      //Error contraseña iguales
      if (this.passwordInput?.value === this.passwordRInput?.value) {
        this.errorContrasenhaIguales = false;
      } else {
        this.errorContrasenhaIguales = true;
      }
      //Comprobar que no haya ningún error y crear el usaurio
      if (this.errorEmail == false && this.errorEmailNoti == false && this.errorContrasenha == false && this.errorContrasenhaIguales == false && !this.errorName) {

        let user = {
          _method: "PATCH",
          user_id: this.userId,
          email: this.emailInput?.value,
          user_pass1: this.passwordInput?.value,
          user_pass2: this.passwordRInput?.value,
          user_mail: this.emailNotiInput?.value,
          user_fullname: this.nameInput?.value,
          pro_id: this.tipoUsuario,
          cliente_id: this.selectedCliente,
          user_status: this.estado,
          acl_establishments: JSON.stringify(this.selectedEstablecimiento),
        };
        this.editarUsuarioSubscription = this.userService.updateUser(user).subscribe({
          next: resp => {
            // console.log(resp);
          }, error: err => {
            this.errorFinalMessage = err.error.message;
            const errorFields = err.error?.error;

            if (errorFields) {
              this.errorFinalMessage = Object.keys(errorFields)
                .map(field => errorFields[field].join(', '))
                .join(' | ');
            } else {
              this.errorFinalMessage = err.message || 'Error desconocido';
            }
            if (!this.waitAfterSave) {
              this.waitAfterSave = true;
              this.errorFinal = true;
              setTimeout(() => {
                this.errorFinal = false;
                this.waitAfterSave = false;
              }, 3500)
            }
          }, complete: () => {
            if (!this.waitAfterSave) {
              this.waitAfterSave = true;
              this.usuarioEditado = true;
              setTimeout(() => {
                this.usuarioEditado = false;
                this.waitAfterSave = false;
                if (this.userDataSer.id == this.userData.id) {
                  this.logout();
                }
              }, 3500);
            }
          }
        })
      }

      /*console.log("Nombre: ", this.nameInput?.value);
      console.log("El ID de usuario es: ", this.userId);
      console.log("Correo electrónico: ", this.emailInput?.value);
      console.log("Contraseña: ", this.passwordInput?.value);
      console.log("Contraseña Repetida: ", this.passwordRInput?.value);
      console.log('El cliente seleccionado es: ', this.selectedCliente);
      console.log("Tipo de Usuario: ", this.tipoUsuario);
      console.log("Estado: ", this.estado);
  
      console.log('---------------------------------------');*/
    }
  }
}
